module.exports = __webpack_public_path__ + "img/footer-overlay.6c43ab6b.png";